'use es6';

export const SIDEBAR_WIDTH = 360;
export const MIN_PANE_SIZE = 24;
export const FINDER_WIDTH = 300;
export const MIN_EDITOR_SIZE = 500;
export const MIN_FINDER_SIZE = 230;
export const MIN_COMPILED_EDITOR_SIZE = 200;